import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { auth } from "./firebaseConfig"; // ✅ Firebase Auth import
import { GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth"; 
import "./Navbar.css"; // ✅ Add styling

function Navbar({ cartLength }) {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState(null);
  const [language, setLanguage] = useState(localStorage.getItem("language") || "zh-TW");
  const [languageDropdown, setLanguageDropdown] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user || null);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    localStorage.setItem("language", lang);
    setLanguageDropdown(false);
  };

  return (
    <div className="navbar">
      <div className="navbar-left">
        <img src="/Homepage/Logo.png" alt="Logo" className="logo" />
      </div>
      <div className="navbar-right">
        <Link to="/">{t("home")}</Link>
        <Link to="/products">{t("products")}</Link>
        <a href="#desserts">{t("desserts")}</a>
        <a href="#drinks">{t("drinks")}</a>
        <a href="#gifts">{t("gifts")}</a>

        <div className="navbar-toolbar">
          {/* Language Selector */}
          <div className="language-selector">
            <button className="language-button" onClick={() => setLanguageDropdown(!languageDropdown)}>
              {language === "en" ? "🇺🇸 English" : language === "zh-TW" ? "🇹🇼 繁體中文" : "🇨🇳 简体中文"}
            </button>
            {languageDropdown && (
              <ul className="language-dropdown">
                <li onClick={() => changeLanguage("en")}>🇺🇸 English</li>
                <li onClick={() => changeLanguage("zh-TW")}>🇹🇼 繁體中文</li>
                <li onClick={() => changeLanguage("zh-CN")}>🇨🇳 简体中文</li>
              </ul>
            )}
          </div>

          {/* User Profile/Login */}
          <div className="toolbar-icon" onClick={() => setProfileDropdown(!profileDropdown)}>
            {user ? (
              <>
                <img src={user.photoURL || "/Homepage/navbar_icon.png"} alt="User" className="profile-image" />
                {profileDropdown && (
                  <div className="profile-dropdown">
                    <p>{t("welcome", { name: user.displayName || user.email })}</p>
                    <button onClick={handleLogout}>{t("logout")}</button>
                  </div>
                )}
              </>
            ) : (
              <>
                <img
                  src="/Homepage/navbar_icon.png"
                  alt="Login"
                  className="profile-image"
                />
                {profileDropdown && (
                  <div className="profile-dropdown">
                    <Link to="/login">{t("login")}</Link>
                    <Link to="/signup">{t("signup")}</Link>
                  </div>
                )}
              </>
            )}
          </div>

          {/* Shopping Cart */}
          <div className="toolbar-icon">
            <Link to="/cart">
              <img src="/Homepage/navbar_pocket.png" alt="Cart" className="cart-image" />
            </Link>
            <span className="cart-count">{cartLength}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;